import { useBrandLoaderData } from "../../../root/rootLoader.ts";

export default function useVirtualStore() {
  const brand = useBrandLoaderData();
  return { isVirtualStore: !!brand.VirtualStore?.companyId };
}
